/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CohortTypeEnum } from '../models/cohort-type-enum';
import { CompanyFirmographicsDto } from '../models/company-firmographics-dto';
import { CompanyPagedDto } from '../models/company-paged-dto';
import { CompanyProductPagedDto } from '../models/company-product-paged-dto';
import { CompanySearchDto } from '../models/company-search-dto';
import { CompanySearchResultPagedDto } from '../models/company-search-result-paged-dto';
import { FeedCategoryEnum } from '../models/feed-category-enum';
import { FeedResponseDto } from '../models/feed-response-dto';
import { ProductDto } from '../models/product-dto';
import { ProductInUseRequestDto } from '../models/product-in-use-request-dto';
import { ProductInUseResponseDto } from '../models/product-in-use-response-dto';
import { UsageMetricDto } from '../models/usage-metric-dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findStackCompanies
   */
  static readonly FindStackCompaniesPath = '/companies/search';

  /**
   * Search companies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStackCompanies$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompanies$Json$Response(params?: {
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
    body?: CompanySearchDto
  }): Observable<StrictHttpResponse<CompanySearchResultPagedDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.FindStackCompaniesPath, 'post');
    if (params) {
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.query('export', params.export, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanySearchResultPagedDto>;
      })
    );
  }

  /**
   * Search companies.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStackCompanies$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompanies$Json(params?: {
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
    body?: CompanySearchDto
  }): Observable<CompanySearchResultPagedDto> {

    return this.findStackCompanies$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CompanySearchResultPagedDto>) => r.body as CompanySearchResultPagedDto)
    );
  }

  /**
   * Search companies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStackCompanies$Csv()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompanies$Csv$Response(params?: {
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
    body?: CompanySearchDto
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.FindStackCompaniesPath, 'post');
    if (params) {
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.query('export', params.export, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/csv'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Search companies.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStackCompanies$Csv$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStackCompanies$Csv(params?: {
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
    body?: CompanySearchDto
  }): Observable<string> {

    return this.findStackCompanies$Csv$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getCompetitors
   */
  static readonly GetCompetitorsPath = '/companies/{companyDomain}/competitors';

  /**
   * Get competitors.
   *
   * This API yields up to 50 competitors per subject company.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompetitors()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompetitors$Response(params: {
    companyDomain: string;
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<CompanyPagedDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetCompetitorsPath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyPagedDto>;
      })
    );
  }

  /**
   * Get competitors.
   *
   * This API yields up to 50 competitors per subject company.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCompetitors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompetitors(params: {
    companyDomain: string;
    page?: number;
    size?: number;
  }): Observable<CompanyPagedDto> {

    return this.getCompetitors$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyPagedDto>) => r.body as CompanyPagedDto)
    );
  }

  /**
   * Path part for operation getCohort
   */
  static readonly GetCohortPath = '/companies/{companyDomain}/cohort/{cohort}';

  /**
   * Get cohort.
   *
   * BuyerCaddy allows for 3 different comparison cohorts for each company being benchmarked.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCohort()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCohort$Response(params: {
    companyDomain: string;
    cohort: CohortTypeEnum;
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<CompanyPagedDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetCohortPath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.path('cohort', params.cohort, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyPagedDto>;
      })
    );
  }

  /**
   * Get cohort.
   *
   * BuyerCaddy allows for 3 different comparison cohorts for each company being benchmarked.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCohort$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCohort(params: {
    companyDomain: string;
    cohort: CohortTypeEnum;
    page?: number;
    size?: number;
  }): Observable<CompanyPagedDto> {

    return this.getCohort$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyPagedDto>) => r.body as CompanyPagedDto)
    );
  }

  /**
   * Path part for operation getUsage
   */
  static readonly GetUsagePath = '/companies/{companyDomain}/cohort/{cohort}/metrics/usage';

  /**
   * Get usage metric.
   *
   * This is the API that delivers the benchmarking results.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsage$Response(params: {
    companyDomain: string;
    cohort: CohortTypeEnum;
    productId?: string;
    vendorDomain?: string;
  }): Observable<StrictHttpResponse<Array<UsageMetricDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetUsagePath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.path('cohort', params.cohort, {});
      rb.query('productId', params.productId, {});
      rb.query('vendorDomain', params.vendorDomain, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UsageMetricDto>>;
      })
    );
  }

  /**
   * Get usage metric.
   *
   * This is the API that delivers the benchmarking results.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUsage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsage(params: {
    companyDomain: string;
    cohort: CohortTypeEnum;
    productId?: string;
    vendorDomain?: string;
  }): Observable<Array<UsageMetricDto>> {

    return this.getUsage$Response(params).pipe(
      map((r: StrictHttpResponse<Array<UsageMetricDto>>) => r.body as Array<UsageMetricDto>)
    );
  }

  /**
   * Path part for operation companyProductsInUse
   */
  static readonly CompanyProductsInUsePath = '/companies/{companyDomain}/products-in-use';

  /**
   * Company Products In Use.
   *
   * This is the API that helps to detect whether a product (s) is in use at a company.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyProductsInUse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyProductsInUse$Response(params: {
    companyDomain: string;
    body?: ProductInUseRequestDto
  }): Observable<StrictHttpResponse<Array<ProductInUseResponseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CompanyProductsInUsePath, 'post');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProductInUseResponseDto>>;
      })
    );
  }

  /**
   * Company Products In Use.
   *
   * This is the API that helps to detect whether a product (s) is in use at a company.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `companyProductsInUse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyProductsInUse(params: {
    companyDomain: string;
    body?: ProductInUseRequestDto
  }): Observable<Array<ProductInUseResponseDto>> {

    return this.companyProductsInUse$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProductInUseResponseDto>>) => r.body as Array<ProductInUseResponseDto>)
    );
  }

  /**
   * Path part for operation companyProducts
   */
  static readonly CompanyProductsPath = '/companies/{companyDomain}/products';

  /**
   * Company Products.
   *
   * This is the API that returns all the detected technology and product installs at a company.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyProducts$Response(params: {
    companyDomain: string;
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CompanyProductsPath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.query('export', params.export, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/csv'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Company Products.
   *
   * This is the API that returns all the detected technology and product installs at a company.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `companyProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyProducts(params: {
    companyDomain: string;
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
  }): Observable<Blob> {

    return this.companyProducts$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation companyProductsJson
   */
  static readonly CompanyProductsJsonPath = '/companies/{companyDomain}/products/json';

  /**
   * Company Products.
   *
   * This is the API that returns all the detected technology and product installs at a company. The format is JSONL
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyProductsJson()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyProductsJson$Response(params: {
    companyDomain: string;
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CompanyProductsJsonPath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.query('export', params.export, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Company Products.
   *
   * This is the API that returns all the detected technology and product installs at a company. The format is JSONL
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `companyProductsJson$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyProductsJson(params: {
    companyDomain: string;
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
  }): Observable<Blob> {

    return this.companyProductsJson$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation companyProductsJsonPaged
   */
  static readonly CompanyProductsJsonPagedPath = '/companies/{companyDomain}/products/paged';

  /**
   * Company Products.
   *
   * This is the API that returns all the detected technology and product installs at a company.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyProductsJsonPaged()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyProductsJsonPaged$Response(params: {
    companyDomain: string;
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<CompanyProductPagedDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CompanyProductsJsonPagedPath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.query('export', params.export, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyProductPagedDto>;
      })
    );
  }

  /**
   * Company Products.
   *
   * This is the API that returns all the detected technology and product installs at a company.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `companyProductsJsonPaged$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyProductsJsonPaged(params: {
    companyDomain: string;
    'X-On-Behalf-Of-User'?: string;

    /**
     * if set then we produce a file associated with X-On-Behalf-Of-User user and charge the user accordingly
     */
    export?: boolean;
    page?: number;
    size?: number;
  }): Observable<CompanyProductPagedDto> {

    return this.companyProductsJsonPaged$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyProductPagedDto>) => r.body as CompanyProductPagedDto)
    );
  }

  /**
   * Path part for operation getRelatedProducts
   */
  static readonly GetRelatedProductsPath = '/companies/{companyDomain}/products/{productId}/related';

  /**
   * Get Related Product.
   *
   * Use this to find all related (complementary/competitor/related) products associated with a single product.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRelatedProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRelatedProducts$Response(params: {
    companyDomain: string;
    productId: string;
    cohort: CohortTypeEnum;
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<Array<ProductDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetRelatedProductsPath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.path('productId', params.productId, {});
      rb.query('cohort', params.cohort, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProductDto>>;
      })
    );
  }

  /**
   * Get Related Product.
   *
   * Use this to find all related (complementary/competitor/related) products associated with a single product.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRelatedProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRelatedProducts(params: {
    companyDomain: string;
    productId: string;
    cohort: CohortTypeEnum;
    page?: number;
    size?: number;
  }): Observable<Array<ProductDto>> {

    return this.getRelatedProducts$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProductDto>>) => r.body as Array<ProductDto>)
    );
  }

  /**
   * Path part for operation getCompanyFeed
   */
  static readonly GetCompanyFeedPath = '/companies/{companyDomain}/feed';

  /**
   * Get company feed.
   *
   * This API yields up to 50 news per subject company.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyFeed()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFeed$Response(params: {
    companyDomain: string;
    category?: Array<FeedCategoryEnum>;

    /**
     * pass this parameter from response to request next portion of the data
     */
    paginationId?: string;
  }): Observable<StrictHttpResponse<FeedResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetCompanyFeedPath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
      rb.query('category', params.category, {});
      rb.query('paginationId', params.paginationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FeedResponseDto>;
      })
    );
  }

  /**
   * Get company feed.
   *
   * This API yields up to 50 news per subject company.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCompanyFeed$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFeed(params: {
    companyDomain: string;
    category?: Array<FeedCategoryEnum>;

    /**
     * pass this parameter from response to request next portion of the data
     */
    paginationId?: string;
  }): Observable<FeedResponseDto> {

    return this.getCompanyFeed$Response(params).pipe(
      map((r: StrictHttpResponse<FeedResponseDto>) => r.body as FeedResponseDto)
    );
  }

  /**
   * Path part for operation getCompanyFirmographics
   */
  static readonly GetCompanyFirmographicsPath = '/companies/{companyDomain}/firmographics';

  /**
   * Get company firmographics.
   *
   * This API returns details about the company by domain
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyFirmographics()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFirmographics$Response(params: {
    companyDomain: string;
  }): Observable<StrictHttpResponse<CompanyFirmographicsDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetCompanyFirmographicsPath, 'get');
    if (params) {
      rb.path('companyDomain', params.companyDomain, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyFirmographicsDto>;
      })
    );
  }

  /**
   * Get company firmographics.
   *
   * This API returns details about the company by domain
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCompanyFirmographics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFirmographics(params: {
    companyDomain: string;
  }): Observable<CompanyFirmographicsDto> {

    return this.getCompanyFirmographics$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyFirmographicsDto>) => r.body as CompanyFirmographicsDto)
    );
  }

}
